const HAS_TIMEZONE = /(Z|[+-]\d{2}:?\d{2})$/i;

export const parseUtcDateTime = (value: string | Date): Date => {
  if (value instanceof Date) return value;
  const normalized = value.includes('T') && !HAS_TIMEZONE.test(value) ? `${value}Z` : value;
  return new Date(normalized);
};

export const formatLocalDateTime = (
  value?: string | Date | null,
  options?: Intl.DateTimeFormatOptions,
): string => {
  if (!value) return '-';
  const date = parseUtcDateTime(value);
  if (Number.isNaN(date.getTime())) return '-';
  return new Intl.DateTimeFormat(undefined, options ?? {
    dateStyle: 'medium',
    timeStyle: 'short',
  }).format(date);
};

export const formatLocalTime = (value?: string | Date | null): string =>
  formatLocalDateTime(value, { hour: '2-digit', minute: '2-digit' });

